<template>
  <section class="timeline users-panel">
    <div class="timeline-scroll">
      <div class="users-string">

        <div class="timeline-header">
        <h2 class="timeline-title" v-if="!open_search">Люди</h2>
        <div class="search" v-if="open_search">
          <div class="input-search">
              <input type="search" placeholder="Поиск" v-model="search" @keyup="searchUsers()" ref="search">
              <img src="@/assets/images/icons/icon_search-b.svg" width="22px">
          </div>
        </div>
        <div class="search-buttons">
          <div class="search-icon" v-if="!open_search" @click="changeState('sports')">
            <img src="@/assets/images/icons/filters.svg" width="24px" />
          </div>
          <div class="search-icon" v-if="!open_search" @click="changeOpenSearch()">
            <img src="@/assets/images/icons/icon_search-b.svg" width="22px" />
          </div>
          <div class="search-close" v-if="open_search" @click="changeOpenSearch()"> 
            <img src="@/assets/images/icons/icon_close.svg" width="22px" />
          </div>
        </div>
      </div>

      </div>

      <div class="users-filters">
        <div class="users-choise">
          <router-link :to="{name: 'users'}" exact-active-class="active" class="button">Поиск друзей</router-link>
          <router-link :to="{name: 'friends'}" exact-active-class="active" class="button">Мои друзья</router-link>
          <router-link :to="{name: 'offers'}" exact-active-class="active" class="button">
            <p>Входящие заявки</p>
            <div class="nav-item__notif" v-if="getNotifications && getNotifications.offers">
              <p>{{ getNotifications.offers }}</p>
            </div>
          </router-link>
          <router-link :to="{name: 'myoffers'}" exact-active-class="active" class="button">Мои заявки</router-link>
        </div>
      </div>
      
      <Sports :sports="getActiveSports" />
    </div>
  </section>
</template>

<script>
export default {
  components: {
    Sports: () => import("@/components/Filters/Sports.vue"),
  },
  data() {
    return {
      filters: this.getActiveFilters || null,
      search: "",
      sharing: false,
      open_search: false
    };
  },
  computed: {
    getNotifications() {
      return this.$store.getters.getUserNotifications
    },
    getActiveSports() {
      return this.$store.getters.getActiveSports;
    },
    filteredPosts() {
      let byTitle = this.todosByTitle();
      let filters = this.getActiveFilters;
      return !filters || filters.length < 1
        ? byTitle
        : this.filteredByCats(byTitle, filters);
    },
  },
  methods: {
    changeOpenSearch() {
      this.open_search = !this.open_search
      !this.open_search || this.search.length > 0
        ? (this.search = '', this.searchUsers()) 
        : this.focusOnSearch()
    },
    focusOnSearch() {
      setTimeout(() => {
        let search = this.$refs.search;
        search ? search.focus() : ''
      }, 100)
    },
    searchUsers() {
      this.search && this.search.length > 2 || this.search.length == 0 ? this.$store.dispatch('setUsersSearch', this.search) : ''
    },
    changeState (element) {
        this.$store.dispatch('changeState', {element: element, val: true})
      },
    todosByTitle() {
      let value = this.search;
      value = value ? value.toUpperCase() : "";
      let posts = this.articles.filter((article) => {
        let prop =
          value[0] === "#"
            ? article.tags.toUpperCase()
            : article.title.toUpperCase();
        return prop.indexOf(value) > -1;
      });
      return posts;
    },
  },
  mounted() {
    this.search = ''
  }
};
</script>
